import { useQuery, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

interface EtiquettesLinkResponse {
  path: string;
}

function generateEtiquettesLink(props: {
  schoolyearId: string;
  schoolId: string;
  viewId: string;
}): Promise<EtiquettesLinkResponse> {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views/${props.viewId}/etiquettes-link`;
  return request(requestURL, {
    method: 'GET',
  });
}

export const ETIQUETTES_LINK_KEY = 'etiquettes-link';

export function useGenerateEtiquettesLink(viewId: string | undefined) {
  const { schoolyear, school } = useSchoolSchoolyear();

  return useQuery({
    queryKey: [schoolyear.id, school.id, viewId, ETIQUETTES_LINK_KEY],
    queryFn: () =>
      generateEtiquettesLink({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        viewId: viewId!,
      }),
    enabled: !!viewId,
  });
}

export function useInvalidateEtiquettesLink() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  return function invalidateEtiquettesLink(viewId: string) {
    return queryClient.invalidateQueries({
      queryKey: [schoolyear.id, school.id, viewId, ETIQUETTES_LINK_KEY],
    });
  };
}
